/** 
 * This info was found outside of Swiper docs, so please remember it:
 * swiper.size === .swiper width (margins included)
 * swiper.virtualSize === .swiper-wrapper width
 * 
 * as I understand it, swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter
 * 
 * Important : For it to work, you can't use property `slidesOffsetAfter`
 * 
 * How to use:
 * 
 ````
 import { toggleSwiperLock } from 'toggleSwiperLock'
 
 const ... = new Swiper(..., {
    on: {
        init: function(swiper) {
          return toggleSwiperLock(swiper)
        },
        resize: function(swiper) {
          return toggleSwiperLock(swiper)
        },
    }
 })
````
 */
export const toggleSwiperLock = (swiper) => {
    const shouldBeLocked = swiper.size === Math.floor(swiper.virtualSize)
    
    /* debug log:*/
    
    // console.log('swiper', 
    //     (shouldBeLocked ? 'should be locked' : 'should be unlocked'), 
    //     Math.floor(swiper.virtualSize), '/', swiper.size)
    
    // console.log({
    //     swiperWidthMarginsIncluded: swiper.size,
    //     swiperWrapperWidth: swiper.virtualSize
    // })
    
    
    swiper.el.classList.toggle('locked', shouldBeLocked)
    swiper.wrapperEl.classList.toggle('locked', shouldBeLocked)
    shouldBeLocked ? swiper.disable() : swiper.enable()
    
    return shouldBeLocked
}